import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { ToastService } from '../../../services/toast.service';
import { StripeService } from '../../../services/stripe.service';
import { SubscriptionService } from '../../../services/subscription.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  email: string = '';
  password: string = '';
  showPassword: boolean = false;
  isOTPRequired: boolean = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private toaster: ToastService,
    private stripeService: StripeService,
    private subscriptionService: SubscriptionService
  ) {}


  login(): void {
  // Basic validation
  if (!this.email || !this.password) {
    this.toaster.showToast("Email and password are required", "error");
    return; // stop here
  }

  // Email format validation
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!emailRegex.test(this.email)) {
    this.toaster.showToast("Please enter a valid email address", "error");
    return; // stop here
  }
  // ✅ Domain validation
  const allowedDomains = [
    "gmail.com",
    "yahoo.com",
    "outlook.com",
    "hotmail.com",
    "protonmail.com"
  ];

  const domain = this.email.split("@")[1]?.toLowerCase();
  if (!allowedDomains.includes(domain)) {
    this.toaster.showToast(`Invalid email domain: ${domain}`, "error");
    return;
  }

  const userData = {
    email: this.email.toLowerCase(),
    password: this.password,
  };

  this.authService.login(userData).subscribe({
    next: (response: any) => {
      const userToStore = {
        _id: response.user._id,
        email: response.user.email,
        name: response.user.name,
        is_email_verified: response.user.is_email_verified,
        is_active: response.user.is_active,
      };
      this.subscriptionService.setSubcription(response.subscription);
      this.authService.setAuthData(response.token, userToStore);
      this.router.navigate(['/'], { replaceUrl: true });
      this.toaster.showToast('Login successful!', 'success');
    },
    error: (error) => {
      if (error?.status === 405) {
        this.isOTPRequired = true;
        this.toaster.showToast(
          'Please verify your email before logging in.',
          'error'
        );
      } else {
        this.toaster.showToast(
          error?.error?.error ?? 'Something went wrong!',
          'error'
        );
      }
    },
  });
}


  navigateToRegister(): void {
    this.router.navigate(['/auth/register']);
  }

  togglePasswordVisibility(passwordInput: HTMLInputElement): void {
    this.showPassword = !this.showPassword;
    passwordInput.type = this.showPassword ? 'text' : 'password';
  }

  navigateToForgotPassword(): void {
    this.router.navigate(['/auth/forgot-password']);
  }
}
